var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.836 23.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.455 2.776 29.836.499v-.5h-8.247l-5.878 14.63L9.024 0H.377v.5l2.781 3.348a1.167 1.167 0 0 1 .377.973v13.155a1.5 1.5 0 0 1-.4 1.305L0 23.078v.489h8.882v-.5L5.75 19.281a1.547 1.547 0 0 1-.431-1.305V6.596l7.8 16.98h.906l6.7-16.98v13.527c0 .357 0 .43-.234.664L18.08 23.12v.5h11.7v-.5l-2.325-2.276a.691.691 0 0 1-.266-.664V3.44a.688.688 0 0 1 .265-.664Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.4ea2fa66615eab6ffb2449ae5624a729.svg";
export { ForwardRef as ReactComponent };